import * as React from 'react'
import { useField } from 'react-final-form'
import * as Styled from '../Form.styles'

const SelectElement = ({
  name,
  type,
  label,
  options = [],
  placeholderText = '',
  validations = null,
  ...rest
}) => {
  const { input, meta } = useField(name, {
    validate: validations,
  })

  return (
    <Styled.Label gridArea={name}>
      <Styled.LabelText className="label input-label">{label}</Styled.LabelText>
      <Styled.SelectDropdown
        {...input}
        {...rest}
        options={options}
        placeholder={placeholderText}
        isTouchedAndValid={Boolean(meta.touched && !meta.error)}
        hasError={Boolean(meta.touched && meta.error)}
        aria-invalid={Boolean(meta.touched && meta.error)}
      />
      {meta.error && meta.touched && (
        <Styled.ErrorText className="error-text">{meta.error}</Styled.ErrorText>
      )}
    </Styled.Label>
  )
}

export default SelectElement
